/* 
  All the paths in the application.
  Always use this PATH constant when routing to a path within the 
  application and avoid using strings as routes could change later on.
*/
export const PATHS = {
  REGISTER: "/register",
  LOGIN: "/login",
  PASSWORD_RESET: "/reset",
  VERIFY: "/verify",
  CONFIRM_EMAIL: "/confirm-email",
  HOME: "/",
  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
};
